import { Component, Inject, OnInit, ViewChild, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DValorDominio } from '@dian/api-basicos-parametricas';
import { DirectionType, HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { DRenta210v18Servicios, DVencimiento } from '@dian-api/renta210v18';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { MessageObservableService } from '../../../../../../services/message-observable.service';


const stepsList = [
  { text: "1", active: false, completed: false, tooltip: '', listHelp: ['800'] },
  { text: "2", active: true, completed: false, tooltip: ' ', listHelp: ['800'] }
];

const tableStructure = [
  { id: 'valorAnticipoDecla', title: 'Valor anticipo año siguiente' },
  { id: 'impNetoAnterior', title: 'Anticipo de renta pagado año anterior' },
  { id: 'retenciones', title: 'Retenciones que le practicaron año anterior' }
];

class Form1 {
  id: number;
  anioDecla: string;
  anioDeclarNombre: string;
  anticipoRentaAnioAnterior: string;
  impNetoAnterior: string;
  valorAnticipoDecla: string;
  retenciones: string;
}
@Component({
  selector: 'app-anticipos-modal',
  templateUrl: './anticipos-modal.component.html',
  styleUrls: ['./anticipos-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio,
    DRenta210v18Servicios
  ]
})
export class AnticiposComponent extends HandlerModal implements OnInit {

  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  public listaAniosDeclarados: DValorDominio[] = [];
  public listValorAnticipo: DValorDominio[] = [];
  public OPERACION_NULA: number = 0;
  public OPERACION_AGREGAR: number = 1;
  public OPERACION_EDITAR: number = 2;
  public OPERACION_BORRAR: number = 3;
  public operacionTabla: number = this.OPERACION_NULA;
  public vencimiento: DVencimiento = new DVencimiento();
  mensajeTabla = "¿Tiene que pagar anticipo de renta para el año siguiente?";
  public model210: DDocumento = new DDocumento();

  @ViewChild('buttonRight') buttonRight: any;
  saveModel = new EventEmitter();
  //activarGuardado=new EventEmitter();
  public showSave: boolean;

  constructor(
    public dialogRef: MatDialogRef<AnticiposComponent>,
    public dutilidades: DOperacionesMatematicasServicio,
    public dNotificacionServicio: DNotificacionServicio,
    public dRenta210: DRenta210v18Servicios,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento,
    private _messagesObs: MessageObservableService
  ) {
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
  }

  ngOnInit() {
    this.startProcess();
  }

  startProcess() {
    this.listenMessage();
    this._messagesObs.sendMessages('calcular126', '');
  }

  protected controlStep(direction: DirectionType): void { }

  public initializeFromComponentFactory() {
    this.inicializeModelo();
    this.initializeTablaDesdeModelo();
    this.getVencimiento();
  }

  private listenMessage() {
    this._messagesObs.getMessages().subscribe(res => {
      if (res.operation === 'calculado126') {
        this.inicializeModelo();
        this.initializeTablaDesdeModelo();
        this.getVencimiento();
      }
    });
  }

  private getVencimiento() {
    const preloader = this.dNotificacionServicio.mostrarDialogoCarga();
    this.dRenta210.obtenerVencimiento(this.model.doc.cab.cs_id_5,this.model.doc.cab.cs_id_1).subscribe(
      (res: DVencimiento) => {
        this.vencimiento = <DVencimiento>res;
        this.calculateOcultas();
        this.inicializeForm();
        preloader.close();
      },
      error => {
        preloader.close();
        this.dNotificacionServicio.mostrarDialogoError('Error obteniendo el vencimiento', error.mensaje);
      });
  }

  protected inicializeForm() {
    this.modelForm = new Form1();
    this.modelForm.id = 0;
    this.modelForm.anioDecla = "";
    this.modelForm.anioDeclarNombre = "";
    this.modelForm.anticipoRentaAnioAnterior = this.vencimiento.impuestoNetoAnterior;
    this.modelForm.impNetoAnterior = this.vencimiento.anticipoRentaAnioAnterior;
    this.modelForm.valorAnticipoDecla = "0";
    this.modelForm.retenciones = this.getCalculateRetenciones();
  }

  protected inicializeModelo() {
    if (this.model.doc.cuerpo.cc_id_802 == undefined) {
      this.model.doc.cuerpo.cc_id_802 = [];
      this.model.doc.cuerpo.cc_id_795 = [];
      this.model.doc.cuerpo.cc_id_796 = [];
      this.model.doc.cuerpo.cc_id_806 = [];
      this.model.doc.cuerpo.cc_id_797 = [];
    }
  }

  protected initializeTablaDesdeModelo() {
    this.dataSourceBody = [];
    for (let i = 0; i < this.model.doc.cuerpo.cc_id_802.length; i++) {
      this.modelForm.id = i;
      this.modelForm.anioDecla = this.model.doc.cuerpo.cc_id_802[i].v;
      if (this.listaAniosDeclarados && this.listaAniosDeclarados.length > 0 && this.listaAniosDeclarados[this.model.doc.cuerpo.cc_id_802[i].v - 1])
        this.modelForm.anioDeclarNombre = this.listaAniosDeclarados[this.model.doc.cuerpo.cc_id_802[i].v - 1].nombre;
      this.modelForm.anticipoRentaAnioAnterior = this.model.doc.cuerpo.cc_id_795[i].v || this.model210.doc.cuerpo.cs_id_795;
      this.modelForm.impNetoAnterior = this.model.doc.cuerpo.cc_id_796[i].v;
      this.modelForm.valorAnticipoDecla = this.model.doc.cuerpo.cc_id_806[i].v;
      this.modelForm.retenciones = this.getCalculateRetenciones();//this.model.doc.cuerpo.cc_id_797[i].v;
      this.dataSourceBody.push(this.modelForm);
      this.inicializeForm();
    }
  }

  public editModeloDesdeForm() {
    this.model.doc.cuerpo.cc_id_802[this.modelForm.id].v = this.modelForm.anioDecla;
    this.model.doc.cuerpo.cc_id_795[this.modelForm.id].v = this.modelForm.anticipoRentaAnioAnterior.toString();
    this.model.doc.cuerpo.cc_id_796[this.modelForm.id].v = this.modelForm.impNetoAnterior.toString();
    this.model.doc.cuerpo.cc_id_806[this.modelForm.id].v = this.modelForm.valorAnticipoDecla.toString();
    this.model.doc.cuerpo.cc_id_797[this.modelForm.id].v = this.modelForm.retenciones.toString();
  }

  public addToModeloDesdeForm() {
    let i = this.modelForm.id + 1;
    this.model.doc.cuerpo.cc_id_802.push({ it: i, v: this.modelForm.anioDecla });
    this.model.doc.cuerpo.cc_id_795.push({ it: i, v: this.modelForm.anticipoRentaAnioAnterior });
    this.model.doc.cuerpo.cc_id_796.push({ it: i, v: this.modelForm.impNetoAnterior });
    this.model.doc.cuerpo.cc_id_806.push({ it: i, v: this.modelForm.valorAnticipoDecla });
    this.model.doc.cuerpo.cc_id_797.push({ it: i, v: this.modelForm.retenciones });

    this.model.doc.cuerpo.cs_id_795 = this.modelForm.impNetoAnterior;
    this.model210.doc.cuerpo.cs_id_795 = this.model.doc.cuerpo.cs_id_795;
  }

  public deleteOnModel(index: number) {
    this.model.doc.cuerpo.cc_id_802.splice(index, 1);
    this.model.doc.cuerpo.cc_id_795.splice(index, 1);
    this.model.doc.cuerpo.cc_id_796.splice(index, 1);
    this.model.doc.cuerpo.cc_id_806.splice(index, 1);
    this.model.doc.cuerpo.cc_id_797.splice(index, 1);

    //reenumerear it
    for (let i = 0; i < this.model.doc.cuerpo.cc_id_802.length; i++) {
      this.model.doc.cuerpo.cc_id_802[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_795[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_796[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_806[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_797[i].it = i + 1;
    }
  }

  public validateFormCompleted(): boolean {
    if (this.modelForm.impNetoAnterior && this.modelForm.impNetoAnterior == '0') {
      return !this.modelForm.anioDecla || !this.modelForm.anticipoRentaAnioAnterior || !this.modelForm.valorAnticipoDecla;
    } return false;
  }

  public redondearFormData() {
    this.modelForm.retenciones = this.dutilidades.redondearValorMoneda(this.modelForm.retenciones.toString(), true);
  }

  saveItem(): void {
    if (this.validateFormCompleted()) {
      this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro");
      return;
    } else {
      //this.redondearFormData();
      if (this.operacionTabla == this.OPERACION_EDITAR) {
        //this.editModeloDesdeForm();
        const valAnt = this.listValorAnticipo.find(item => item.valor == this.modelForm.valorAnticipoDecla);
        this.modelForm.valorAnticipoDecla = valAnt ? valAnt.nombre : '0';
        this.modelForm.anioDeclarNombre = this.listaAniosDeclarados.find(item => item.valor == this.modelForm.anioDecla).nombre;
        this.dataSourceBody.forEach((el) => {
          if (el.id == this.modelForm.id) {
            el = this.modelForm;
          }
        });
      } else if (this.operacionTabla == this.OPERACION_AGREGAR) {
        this.modelForm.id = this.dataSourceBody.length;
        this.dataSourceBody.push(this.modelForm);    
        //this.addToModeloDesdeForm();
      }

      //Recalcular y reinicializar
      this.operacionCs781();
      this.inicializeForm();
      this.operacionTabla = this.OPERACION_NULA;
    }
  }

  eventTable($event: string): void {
    if ($event === 'add') {
      this.operacionTabla = this.OPERACION_AGREGAR;
      this.calculateOcultas();
    }
    if ($event === 'edit') this.operacionTabla = this.OPERACION_EDITAR;
    if ($event === 'delete') {
      this.operacionTabla = this.OPERACION_BORRAR;
      this.cleanOcultas();
      this.calculateOcultas();
    }
    this.operacionCs781();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if (this.operacionTabla == this.OPERACION_EDITAR) {//editando
      this.modelForm = this.dataSourceBody[index];
    }
    if (this.operacionTabla == this.OPERACION_BORRAR) {//borrando
      //this.deleteOnModel(index);
      this.operacionTabla = this.OPERACION_NULA;
    }
  }

  cancel(): void {
    this.inicializeForm();
    this.cleanOcultas();
    this.operacionTabla = this.OPERACION_NULA;
  }

  operacionCs781() {
    let suma = "0";
    for (let i = 0; i < this.dataSourceBody.length; i++) {
      suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.dataSourceBody[i].valorAnticipoDecla, suma);
    }
    this.model.doc.cuerpo.cs_id_806 = suma;
  }

  getCalculateRetenciones(): string {
    let sum = "0";
    const fieldsRetenciones = ['cc_id_284', 'cc_id_310', 'cc_id_334', 'cc_id_346', 'cc_id_362', 'cc_id_500', 'cc_id_521', 'cc_id_575', 'cc_id_594', 'cc_id_615', 'cc_id_649', 'cc_id_364'];
    const cas546 = this.getValueCas('cc_id_546');

    if (cas546 == '1')
      fieldsRetenciones.push('cc_id_554');

    for (const item of fieldsRetenciones) {
      const data = this.model.doc.cuerpo[item];
      if (data && Array.isArray(data)) {
        if (!data.length) continue;
        for (const subItem of data)
          sum = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, subItem.v, sum);
      } else {
        if (!data) continue;
        sum = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, data, sum);
      }
    }
    return sum;
  }

  calculateOcultas() {
    const cas796 = String(this.modelForm.anticipoRentaAnioAnterior ? this.modelForm.anticipoRentaAnioAnterior : '0');
    const cas797 = this.getCalculateRetenciones();
    const cas126 = this.getValueCas('cs_id_126', false);
    const sum796and126 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas796, cas126);

    const cas803 = this.modelForm.anioDecla == '1' ? '0.25' :
      this.modelForm.anioDecla == '2' ? '0.50' :
        this.modelForm.anioDecla == '3' ? '0.75' : "0";
    const cas801 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.DIVISION, sum796and126, "2");
    const mul801x803 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, cas801, cas803);
    const cas804 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, mul801x803, cas797);

    const mul126x803 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, cas126, cas803);
    const cas805 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, mul126x803, cas797);

    this.model.doc.cuerpo.cc_id_801 = [{ it: 1, v: cas801 }];
    this.model.doc.cuerpo.cc_id_803 = [{ it: 1, v: cas803 }];
    this.model.doc.cuerpo.cc_id_797 = [{ it: 1, v: cas797 }];
    this.model.doc.cuerpo.cs_id_797 = cas797;

    if (this.listValorAnticipo.length)
      this.listValorAnticipo = [];

    const ddominiovalue1 = new DValorDominio();
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, cas804, "0")) {
      const rounded804 = this.dutilidades.redondearValorMoneda(cas804);
      const rounded804formated = this.dutilidades.redondearValorMoneda(cas804, true);
      this.model.doc.cuerpo.cc_id_804 = [{ it: 1, v: rounded804 }];
      ddominiovalue1.nombre = rounded804formated;
      ddominiovalue1.valor = rounded804;
    } else {
      this.model.doc.cuerpo.cc_id_804 = [{ it: 1, v: '0' }];
      ddominiovalue1.nombre = '0';
      ddominiovalue1.valor = '0';
    }

    const ddominiovalue2 = new DValorDominio();
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, cas805, "0")) {
      const rounded805 = this.dutilidades.redondearValorMoneda(cas805);
      const rounded805formated = this.dutilidades.redondearValorMoneda(cas805, true);
      this.model.doc.cuerpo.cc_id_805 = [{ it: 1, v: rounded805 }];
      ddominiovalue2.nombre = rounded805formated;
      ddominiovalue2.valor = rounded805;
    } else {
      this.model.doc.cuerpo.cc_id_805 = [{ it: 1, v: '0' }];
      ddominiovalue2.nombre = '0';
      ddominiovalue2.valor = '0';
    }

    if (
      this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, ddominiovalue1.valor, "0") || 
      this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, ddominiovalue2.valor, "0")
    ) {
      if (this.modelForm.anioDecla !== '1')
        this.listValorAnticipo.push(ddominiovalue1);
      this.listValorAnticipo.push(ddominiovalue2); 
    } else {
      if (
        this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, ddominiovalue1.valor, "0") &&
        this.modelForm.anioDecla !== '1'
      ) 
        this.listValorAnticipo.push(ddominiovalue1);
  
      //if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, ddominiovalue2.valor, "0")) 
      this.listValorAnticipo.push(ddominiovalue2); 
    }
        
    this.model.doc.cuerpo.cs_id_795 = this.modelForm.impNetoAnterior;
    this.model210.doc.cuerpo.cs_id_795 = this.model.doc.cuerpo.cs_id_795;
  }

  private cleanOcultas() {
    this.listValorAnticipo = [];
    this.model.doc.cuerpo.cc_id_801 = [];
    this.model.doc.cuerpo.cc_id_803 = [];
    this.model.doc.cuerpo.cc_id_804 = [];
    this.model.doc.cuerpo.cc_id_805 = [];
  }

  private getValueCas(idCas: string, is2100: boolean = true) {
    let sum = "0";
    const dataCas = is2100 ? this.model.doc.cuerpo[idCas] : this.model210.doc.cuerpo[idCas];
    if (dataCas && Array.isArray(dataCas) && dataCas.length) {
      for (const subItem of dataCas)
        sum = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, subItem.v, sum);
    } else {
      if (dataCas && !Array.isArray(dataCas))
        return dataCas;
      return sum;
    }
    return sum;
  }

  closeModal() {
    this.initializeTablaDesdeModelo();
    this.operacionCs781();
    this.dialogRef.close("");
  }

  guardar() {
    this.model.doc.cuerpo.cc_id_802 = undefined;
    this.inicializeModelo();
    for (let i = 0; i < this.dataSourceBody.length; i++) {
      this.modelForm = this.dataSourceBody[i];
      this.addToModeloDesdeForm();
    }
   // this.activarGuardado.emit(true);
    this.saveModel.emit(true);
    this.closeModal();
  }
}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/impuesto-renta/anticipos-modal/anticipos-modal.component.ts